(() => {
  const guard = window.FluffDiscoveryGuard;
  if (!guard) return;
  const root = document.documentElement;
  const sectionSelector = '#main > [id$="__6eae51cd-39d0-4fec-9a6f-91b665a13140"], #main > [id$="__b4def092-8028-40c9-8cad-0c8718aeee45"], #main .shopify-section--apps:has(.boost-sd__filter-product-list)';
  let failureTimer;
  let scheduled = false;
  let observer;
  let filterTimer;
  let resultsRequest;
  let resultsVersion = 0;
  const mobileFilters = window.matchMedia('(max-width: 899px)');
  const isSearchUrl = (url) => /\/search\/?$/.test(url.pathname);
  const announce = (text) => {
    const drawerStatus = document.querySelector('[data-fluff-filter-dialog][open] [data-fluff-drawer-status]');
    document.querySelectorAll('[data-fluff-native-status], [data-fluff-drawer-status]').forEach((status) => {
      const active = drawerStatus ? status === drawerStatus : status.hasAttribute('data-fluff-native-status');
      status.textContent = active ? text : '';
    });
  };
  const closeSortMenus = (except = null, restoreFocus = false) => {
    document.querySelectorAll('[data-fluff-sort-menu]').forEach((menu) => {
      if (menu === except) return;
      const toggle = menu.querySelector('[data-fluff-sort-toggle]');
      const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', 'false');
      menu.querySelector('[data-fluff-sort-list]').hidden = true;
      if (wasOpen && restoreFocus) toggle.focus({ preventScroll: true });
    });
  };
  const openSortMenu = (menu, last = false, focusItems = true) => {
    closeSortMenus(menu);
    menu.querySelector('[data-fluff-sort-toggle]').setAttribute('aria-expanded', 'true');
    menu.querySelector('[data-fluff-sort-list]').hidden = false;
    const items = [...menu.querySelectorAll('[data-fluff-sort-value]')];
    const selected = menu.querySelector('[aria-checked="true"]');
    if (focusItems) (last ? items.at(-1) : selected || items[0])?.focus({ preventScroll: true });
  };
  const enhanceFilters = () => {
    document.querySelectorAll('[data-fluff-native]').forEach((element) => {
      element.setAttribute('data-fluff-auto-filters', '');
      element.querySelectorAll('[data-fluff-native-swatch]').forEach((swatch) => {
        swatch.setAttribute('role', 'button');
        if (!swatch.hasAttribute('aria-pressed')) swatch.setAttribute('aria-pressed', 'false');
      });
      const form = element.querySelector('.fluff-native__filters');
      const drawer = element.querySelector('[data-fluff-filter-dialog]');
      const destination = element.querySelector(mobileFilters.matches ? '[data-fluff-drawer-body]' : '[data-fluff-filter-panel]');
      if (form && destination && form.parentElement !== destination) {
        if (drawer?.open) drawer.close();
        destination.append(form);
      }
      for (const mode of ['desktop', 'mobile']) {
        const allowed = mode === 'desktop' ? ['2', '3', '4'] : ['1', '2'];
        let columns = mode === 'desktop' ? '3' : '2';
        try {
          const saved = sessionStorage.getItem(`fluff-native-columns-${mode}`);
          if (allowed.includes(saved)) columns = saved;
        } catch (_) {}
        element.setAttribute(`data-fluff-columns-${mode}`, columns);
        element.querySelectorAll(`[data-fluff-grid="${mode}"]`).forEach((input) => { input.checked = input.value === columns; });
      }
    });
  };
  const formUrl = (form) => {
    const url = new URL(form.action, location.href);
    url.search = new URLSearchParams(new FormData(form)).toString();
    for (const key of ['filter.v.price.gte', 'filter.v.price.lte']) {
      if (url.searchParams.get(key) === '') url.searchParams.delete(key);
    }
    if (!url.searchParams.get('view')) url.searchParams.delete('view');
    url.searchParams.set('fluff_native', '1');
    if (isSearchUrl(url)) url.searchParams.set('type', 'product');
    return url;
  };
  const refreshResults = async (url, push = true) => {
    clearTimeout(filterTimer);
    url = new URL(url);
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    url.searchParams.set('fluff_native', '1');
    if (isSearchUrl(url)) url.searchParams.set('type', 'product');
    const current = document.querySelector('[data-fluff-native]');
    if (!current) return;
    const version = ++resultsVersion;
    resultsRequest?.abort();
    const controller = new AbortController();
    resultsRequest = controller;
    const timeout = setTimeout(() => controller.abort(), 10000);
    const openFilters = new Set([...current.querySelectorAll('details[open][data-fluff-filter-key]')].map((element) => element.dataset.fluffFilterKey));
    announce(current.dataset.updatingText);
    current.querySelector('.fluff-native__products').setAttribute('aria-busy', 'true');
    const updating = current.querySelector('[data-fluff-updating]');
    if (updating) updating.hidden = false;
    const requestUrl = new URL(url);
    // Switching alternate templates changes the section ID, so request the full
    // HTML for that transition and extract only the independent results section.
    if ((url.searchParams.get('view') || '') === current.dataset.fluffView) {
      requestUrl.searchParams.set('section_id', current.dataset.sectionId);
    }
    try {
      const response = await fetch(requestUrl, { signal: controller.signal });
      if (!response.ok) throw new Error('Results unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      let next = html.querySelector('[data-fluff-native]');
      if (!next) throw new Error('Results missing');
      if (version !== resultsVersion) return;
      const focused = current.contains(document.activeElement) ? document.activeElement : null;
      const focusKey = focused?.closest('[data-fluff-filter-key]')?.dataset.fluffFilterKey;
      const focusedName = focused?.name;
      const focusedValue = focused?.value;
      const focusedType = focused?.type;
      const wasSummary = focused?.tagName === 'SUMMARY';
      const wasSortToggle = focused?.hasAttribute('data-fluff-sort-toggle');
      const focusedSelectName = focused?.closest('[data-fluff-sort-menu]')?.dataset.fluffSelectName || 'sort_by';
      const wasRefine = focused?.hasAttribute('data-fluff-open-filters');
      const wasClear = focused?.hasAttribute('data-fluff-clear-all');
      const wasFilterReset = focused?.matches('.fluff-native__clear, .fluff-native__filters > a');
      const wasDrawerClose = focused?.hasAttribute('data-fluff-close-filters');
      const wasDrawerFooter = wasDrawerClose && Boolean(focused?.closest('.fluff-native__drawer-footer'));
      next.querySelectorAll('[data-fluff-filter-key]').forEach((element) => {
        element.open = openFilters.has(element.dataset.fluffFilterKey);
      });
      const oldDrawer = current.querySelector('[data-fluff-filter-dialog]');
      const drawerOpen = oldDrawer?.open;
      const drawerScroll = current.querySelector('[data-fluff-drawer-body]')?.scrollTop || 0;
      if (drawerOpen && mobileFilters.matches) {
        const incomingDrawer = next.querySelector('[data-fluff-filter-dialog]');
        const incomingTitle = incomingDrawer.querySelector('h2');
        const title = oldDrawer.querySelector('h2');
        oldDrawer.id = incomingDrawer.id;
        oldDrawer.setAttribute('aria-labelledby', incomingDrawer.getAttribute('aria-labelledby'));
        title.id = incomingTitle.id;
        title.textContent = incomingTitle.textContent;
        oldDrawer.querySelector('[data-fluff-clear-all]').hidden = incomingDrawer.querySelector('[data-fluff-clear-all]').hidden;
        oldDrawer.querySelector('.fluff-native__drawer-footer button').textContent = incomingDrawer.querySelector('.fluff-native__drawer-footer button').textContent;
        current.querySelector('.fluff-native__filters').replaceWith(next.querySelector('.fluff-native__filters'));
        current.querySelector('.fluff-native__products').replaceWith(next.querySelector('.fluff-native__products'));
        const reset = current.querySelector('[data-fluff-native-reset]');
        if (reset) reset.replaceWith(next.querySelector('[data-fluff-native-reset]'));
        current.dataset.sectionId = next.dataset.sectionId;
        current.dataset.fluffView = next.dataset.fluffView;
        next = current;
      } else {
        current.replaceWith(next);
      }
      enhanceFilters();
      const nextDrawer = next.querySelector('[data-fluff-filter-dialog]');
      if (nextDrawer?.open) {
        next.querySelector('[data-fluff-open-filters]').setAttribute('aria-expanded', 'true');
        next.querySelector('[data-fluff-drawer-body]').scrollTop = drawerScroll;
      }
      if (push && url.href !== location.href) history.pushState({ fluffNative: true }, '', url);
      else if (!push && url.href !== location.href) history.replaceState({ fluffNative: true }, '', url);
      const fullBrowsing = next.querySelector('[data-fluff-full-browsing]');
      if (fullBrowsing) fullBrowsing.href = makeUrl(false).href;
      let focusTarget;
      if (wasSortToggle) {
        focusTarget = [...next.querySelectorAll('[data-fluff-sort-menu]')].find((menu) => (menu.dataset.fluffSelectName || 'sort_by') === focusedSelectName)?.querySelector('[data-fluff-sort-toggle]');
      } else if (wasRefine) {
        focusTarget = next.querySelector('[data-fluff-open-filters]');
      } else if (wasClear) {
        const clear = next.querySelector('[data-fluff-clear-all]');
        focusTarget = clear.hidden ? next.querySelector('[data-fluff-close-filters]') : clear;
      } else if (wasFilterReset) {
        focusTarget = next.querySelector('.fluff-native__clear, .fluff-native__filters > a');
      } else if (wasDrawerClose) {
        focusTarget = next.querySelector(wasDrawerFooter ? '.fluff-native__drawer-footer button' : '[data-fluff-close-filters]');
      } else if (wasSummary) {
        focusTarget = [...next.querySelectorAll('[data-fluff-filter-key]')].find((element) => element.dataset.fluffFilterKey === focusKey)?.querySelector('summary');
      } else if (focusedName) {
        focusTarget = [...next.querySelectorAll('input, select')].find((element) => element.name === focusedName && (focusedType !== 'checkbox' || element.value === focusedValue));
        if (focusTarget?.type === 'number') focusTarget.value = focusedValue;
      }
      if (!nextDrawer?.open || nextDrawer.contains(focusTarget)) focusTarget?.focus({ preventScroll: true });
      announce(next.querySelector('.fluff-native__count')?.textContent || '');
    } catch (_) {
      if (version === resultsVersion) location.assign(url.href);
    } finally {
      clearTimeout(timeout);
    }
  };
  const submitForm = (form) => {
    if (!form.reportValidity()) return;
    if (form.matches('.fluff-native__filters, [data-fluff-native-reset]')) refreshResults(formUrl(form));
    else HTMLFormElement.prototype.submit.call(form);
  };
  const visible = (element) => {
    if (!element || !element.getClientRects().length) return false;
    for (let node = element; node instanceof Element; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    }
    return true;
  };
  const makeUrl = (native) => {
    const url = new URL(location.href);
    for (const key of [...url.searchParams.keys()]) {
      if (key.startsWith('pf_') || key === 'page' || (!native && key.startsWith('filter.'))) url.searchParams.delete(key);
    }
    url.searchParams.set('fluff_native', native ? '1' : '0');
    if (isSearchUrl(url)) url.searchParams.set('type', 'product');
    if (!native && /^fluff-(8|16|32|48)$/.test(url.searchParams.get('view') || '')) url.searchParams.delete('view');
    return url;
  };
  const keepNativeForms = () => {
    if (root.dataset.fluffDiscovery !== 'native') return;
    document.querySelectorAll('form[action]').forEach((form) => {
      const action = new URL(form.getAttribute('action'), location.href);
      if (action.origin !== location.origin || !isSearchUrl(action)) return;
      form.setAttribute('data-fluff-native-form', '');
      for (const [name, value] of [['fluff_native', '1'], ['type', 'product']]) {
        const inputs = form.querySelectorAll(`input[name="${name}"]`);
        if (inputs.length) inputs.forEach((input) => { input.value = value; });
        else {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.append(input);
        }
      }
    });
  };
  const settleNative = () => {
    clearTimeout(failureTimer);
    observer?.disconnect();
    const focused = guard.focusedBeforeRecovery || document.activeElement;
    guard.focusedBeforeRecovery = null;
    const restoreFocus = [...document.querySelectorAll(sectionSelector)].some((section) => section.contains(focused));
    document.querySelectorAll(sectionSelector).forEach((section) => {
      section.inert = true;
      section.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-fluff-full-browsing]').forEach((link) => { link.href = makeUrl(false).href; });
    keepNativeForms();
    if (guard.discoveryPage && new URL(guard.initialUrl).search !== location.search) {
      location.replace(makeUrl(true).href);
      return;
    }
    if (guard.activated && guard.discoveryPage) {
      const native = document.querySelector('[data-fluff-native]');
      if (restoreFocus) native?.querySelector('h1')?.focus();
      if (native) announce(native.dataset.fallbackText);
      guard.activated = false;
    }
  };
  const ready = () => {
    const widget = document.querySelector('#main .boost-sd__filter-product-list--ready');
    if (!widget) return false;
    const busy = [...widget.querySelectorAll('[aria-busy="true"], [class*="boost-sd"][class*="loading"]')].some(visible);
    if (busy) return false;
    const card = [...widget.querySelectorAll('.boost-sd__product-item a[href*="/products/"]')].find((link) => link.textContent.trim() && visible(link));
    const empty = [...widget.querySelectorAll('.boost-sd__no-search-result-page-empty')].some((element) => element.textContent.trim() && visible(element));
    return Boolean(card || empty);
  };
  const check = () => {
    scheduled = false;
    if (guard.locked) return;
    if (ready()) {
      clearTimeout(guard.timer);
      clearTimeout(failureTimer);
      failureTimer = null;
      root.dataset.fluffDiscovery = 'boost';
    } else if (root.dataset.fluffDiscovery === 'boost' && !failureTimer) {
      failureTimer = setTimeout(guard.useNative, 6000);
    }
  };
  const schedule = () => {
    if (scheduled || guard.locked) return;
    scheduled = true;
    requestAnimationFrame(check);
  };
  const start = () => {
    enhanceFilters();
    document.addEventListener('fluff:discovery-native', settleNative);
    if (root.dataset.fluffDiscovery === 'native') {
      settleNative();
      return;
    }
    if (!guard.discoveryPage || !document.querySelector('[data-fluff-native]')) return;
    const main = document.querySelector('#main');
    observer = new MutationObserver(schedule);
    observer.observe(main, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-busy'] });
    check();
  };
  document.addEventListener('click', (event) => {
    const sortToggle = event.target.closest?.('[data-fluff-sort-toggle]');
    if (sortToggle && root.dataset.fluffDiscovery === 'native') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (sortToggle.getAttribute('aria-expanded') === 'true') closeSortMenus(null, true);
      else openSortMenu(sortToggle.closest('[data-fluff-sort-menu]'), false, event.detail === 0);
      return;
    }
    const sortChoice = event.target.closest?.('[data-fluff-sort-value]');
    if (sortChoice && root.dataset.fluffDiscovery === 'native') {
      event.preventDefault();
      event.stopImmediatePropagation();
      const selectName = sortChoice.closest('[data-fluff-sort-menu]').dataset.fluffSelectName || 'sort_by';
      const select = sortChoice.closest('[data-fluff-native]').querySelector(`select[name="${selectName}"]`);
      const changed = select.value !== sortChoice.dataset.fluffSortValue;
      select.value = sortChoice.dataset.fluffSortValue;
      closeSortMenus(null, true);
      if (changed) submitForm(select.form);
      return;
    }
    if (!event.target.closest?.('[data-fluff-sort-menu]')) closeSortMenus();
    const backdrop = event.target.matches?.('[data-fluff-filter-dialog]') ? event.target : null;
    if (backdrop?.open) {
      const bounds = backdrop.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
        event.preventDefault();
        event.stopImmediatePropagation();
        backdrop.close();
        return;
      }
    }
    const clearAll = event.target.closest?.('[data-fluff-clear-all]');
    if (clearAll && root.dataset.fluffDiscovery === 'native') {
      event.preventDefault();
      event.stopImmediatePropagation();
      const url = formUrl(clearAll.closest('[data-fluff-native]').querySelector('.fluff-native__filters'));
      for (const key of [...url.searchParams.keys()]) {
        if (key.startsWith('filter.')) url.searchParams.delete(key);
      }
      refreshResults(url);
      return;
    }
    const drawerControl = event.target.closest?.('[data-fluff-open-filters], [data-fluff-close-filters]');
    if (drawerControl && root.dataset.fluffDiscovery === 'native') {
      event.preventDefault();
      event.stopImmediatePropagation();
      const drawer = drawerControl.closest('[data-fluff-native]').querySelector('[data-fluff-filter-dialog]');
      if (drawerControl.hasAttribute('data-fluff-open-filters') && mobileFilters.matches) {
        if (!drawer.open) {
          drawer.removeAttribute('data-fluff-restored');
          drawer.showModal();
          drawerControl.setAttribute('aria-expanded', 'true');
        }
      } else if (drawer.open) {
        drawer.close();
      }
      return;
    }
    const swatch = event.target.closest?.('[data-fluff-native-swatch]');
    if (swatch && root.dataset.fluffDiscovery === 'native' && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const card = swatch.closest('.fluff-native__card');
      const productLink = card?.querySelector('[data-fluff-product-link]');
      if (productLink) {
        event.preventDefault();
        event.stopImmediatePropagation();
        productLink.href = swatch.href;
        const image = productLink.querySelector('.fluff-native__image');
        if (image?.tagName === 'IMG' && swatch.dataset.fluffImage) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = swatch.dataset.fluffImage;
          image.alt = swatch.dataset.fluffImageAlt || '';
        }
        if (swatch.hasAttribute('data-fluff-variant-price')) {
          const sale = swatch.dataset.fluffVariantSale === 'true';
          const price = productLink.querySelector('[data-fluff-price]');
          if (price) {
            price.textContent = swatch.dataset.fluffVariantPrice;
            price.classList.toggle('fluff-native__sale-price', sale);
          }
          const compare = productLink.querySelector('[data-fluff-compare-price]');
          if (compare) compare.textContent = swatch.dataset.fluffVariantCompare;
          productLink.querySelectorAll('[data-fluff-compare-price], [data-fluff-sale-badge], [data-fluff-regular-label], [data-fluff-sale-label]').forEach((element) => { element.hidden = !sale; });
          const soldOut = productLink.querySelector('[data-fluff-sold-out]');
          if (soldOut) soldOut.hidden = swatch.dataset.fluffVariantAvailable === 'true';
        }
        card.querySelectorAll('[data-fluff-native-swatch]').forEach((choice) => {
          choice.setAttribute('aria-pressed', String(choice === swatch));
        });
        const prices = [...productLink.querySelector('.fluff-native__prices').children].filter((element) => !element.hidden).map((element) => element.textContent.trim()).join(' ');
        const soldOut = productLink.querySelector('[data-fluff-sold-out]');
        const availability = soldOut?.hidden ? card.closest('[data-fluff-native]').dataset.availableText : soldOut?.textContent.trim();
        announce(`${swatch.getAttribute('aria-label')}. ${prices}. ${availability || ''}`);
        return;
      }
    }
    const submit = event.target.closest?.('[data-fluff-native-form] button[type="submit"]');
    if (submit) {
      event.preventDefault();
      event.stopImmediatePropagation();
      submitForm(submit.form);
      return;
    }
    const resultsLink = event.target.closest?.('.fluff-native__filters > a');
    if (resultsLink && root.dataset.fluffDiscovery === 'native' && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      event.stopImmediatePropagation();
      refreshResults(new URL(resultsLink.href));
      return;
    }
    const full = event.target.closest?.('[data-fluff-full-browsing]');
    if (full) {
      try { sessionStorage.removeItem(guard.key); } catch (_) {}
    }
    if (root.dataset.fluffDiscovery !== 'native') return;
    const link = event.target.closest?.('a[href]');
    if (!link || full || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && /\/(collections\/[^/]+|search)\/?$/.test(url.pathname)) {
      url.searchParams.set('fluff_native', '1');
      if (isSearchUrl(url)) url.searchParams.set('type', 'product');
      link.href = url.href;
    }
  }, true);
  document.addEventListener('keydown', (event) => {
    const swatch = event.target.closest?.('[data-fluff-native-swatch]');
    if (swatch && event.key === ' ' && root.dataset.fluffDiscovery === 'native') {
      event.preventDefault();
      event.stopImmediatePropagation();
      swatch.click();
      return;
    }
    const menu = event.target.closest?.('[data-fluff-sort-menu]');
    if (menu && root.dataset.fluffDiscovery === 'native') {
      const open = menu.querySelector('[data-fluff-sort-toggle]').getAttribute('aria-expanded') === 'true';
      if (event.key === 'Escape' && open) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeSortMenus(null, true);
        return;
      }
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!open) openSortMenu(menu, event.key === 'ArrowUp' || event.key === 'End');
        else {
          const items = [...menu.querySelectorAll('[data-fluff-sort-value]')];
          const current = items.indexOf(document.activeElement);
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (current + (event.key === 'ArrowUp' ? -1 : 1) + items.length) % items.length;
          items[index]?.focus({ preventScroll: true });
        }
        return;
      }
      if (event.key === 'Tab') closeSortMenus();
    }
    const form = event.target.closest?.('[data-fluff-native-form]');
    if (!form || event.key !== 'Enter' || event.target.tagName !== 'INPUT') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitForm(form);
  }, true);
  document.addEventListener('change', (event) => {
    const grid = event.target.closest?.('[data-fluff-grid]');
    if (grid && root.dataset.fluffDiscovery === 'native') {
      event.stopImmediatePropagation();
      const mode = grid.dataset.fluffGrid;
      const allowed = mode === 'desktop' ? ['2', '3', '4'] : ['1', '2'];
      if (!allowed.includes(grid.value)) return;
      try { sessionStorage.setItem(`fluff-native-columns-${mode}`, grid.value); } catch (_) {}
      enhanceFilters();
      return;
    }
    const form = event.target.form?.matches('.fluff-native__filters') ? event.target.form : event.target.closest?.('.fluff-native__filters');
    if (!form || root.dataset.fluffDiscovery !== 'native') return;
    event.stopImmediatePropagation();
    resultsVersion += 1;
    resultsRequest?.abort();
    clearTimeout(filterTimer);
    filterTimer = setTimeout(() => submitForm(form), event.target.type === 'checkbox' ? 120 : 0);
  }, true);
  document.addEventListener('input', (event) => {
    const form = event.target.closest?.('.fluff-native__filters');
    if (!form || event.target.type !== 'number' || root.dataset.fluffDiscovery !== 'native') return;
    event.stopImmediatePropagation();
    resultsVersion += 1;
    resultsRequest?.abort();
    clearTimeout(filterTimer);
    filterTimer = setTimeout(() => submitForm(form), 600);
  }, true);
  window.addEventListener('popstate', () => {
    if (root.dataset.fluffDiscovery === 'native') refreshResults(new URL(location.href), false);
  });
  mobileFilters.addEventListener('change', enhanceFilters);
  document.addEventListener('close', (event) => {
    if (mobileFilters.matches && event.target.matches?.('[data-fluff-filter-dialog]') && event.target.isConnected) {
      const toggle = event.target.closest('[data-fluff-native]')?.querySelector('[data-fluff-open-filters]');
      toggle?.setAttribute('aria-expanded', 'false');
      toggle?.focus({ preventScroll: true });
    }
  }, true);
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-fluff-native-form]')) return;
    event.stopImmediatePropagation();
    try { sessionStorage.setItem(guard.key, String(Date.now() + 900000)); } catch (_) {}
    if (event.target.matches('.fluff-native__filters, [data-fluff-native-reset]')) {
      event.preventDefault();
      submitForm(event.target);
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
